import { render, staticRenderFns } from "./ProductPublish.vue?vue&type=template&id=d0e31aaa&"
import script from "./ProductPublish.vue?vue&type=script&lang=js&"
export * from "./ProductPublish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports